import md5 from 'blueimp-md5'
import { stringifyDeep, stringify } from './url'
import Cookies from '../utils/cookie'
import { COOKIE_DOMAIN } from '../constants'
import store from '@/store'

const REQ_METHOD = {
  post: 'post',
  get: 'get'
}

const getWebToken = () => {
  // 原来_wtk正确的token是encode一次的。
  //Cookies.set方法也会encode一次，Cookies.get方法会decode一次。老登陆没问题
  //和PC登陆打通后，PC是直接种的，没有经过Cookies.set方法，而我们用Cookies.get取的时候会decode一次，出现问题
  let originalToken = Cookies.get('_wtk') || ''
  while (originalToken !== decodeURIComponent(originalToken)) {
    originalToken = decodeURIComponent(originalToken)
  }
  return encodeURIComponent(originalToken)
}
const getUserId = () => Cookies.get('_uid') || ''

function encryptRequestParam(options, reqMethodType = REQ_METHOD.post) {
  const _params = {}
  try {
    _params._lat = defaultParams.lat
    _params._lng = defaultParams.lng
    _params._ft = defaultParams.ft // 返回数据格式：json or xml
    _params._sm = defaultParams.sm // 加密方式
    _params._domid = defaultParams.domid // domain ID
    _params._aid = defaultParams.aid.business_pc // AppId
    _params._did = defaultParams.did // 设备id
    _params._ch = defaultParams.ch.wap // 渠道号
    _params._tk = getWebToken() // token
    _params._uid = getUserId()
    _params._orgid = (store.state.user.userCurrentOrg && store.state.user.userCurrentOrg.id) || ''
    _params._shopid = (store.state.user.currentShop && store.state.user.currentShop.id) || ''
    options = stringifyDeep(options)
    let s = ''
    const keys = []
    const params = Object.assign(_params, options)
    for (const k in params) {
      keys.push(k)
    }
    keys.sort()
    for (let i = 0; i < keys.length; i++) {
      s = s + keys[i] + '=' + params[keys[i]]
    }
    s += defaultParams.offset
    params._sig = md5(s) // 参数字符串签名
    // console.log('---req---', stringify(params))
    if (reqMethodType === REQ_METHOD.get) {
      return params
    } else {
      return stringify(params)
    }
  } catch (e) {
    throw new Error('本地加签错误' + e)
  }
}

const defaultParams = {
  ft: 'json',
  sm: 'md5',
  domid: 1000,
  offset: '0ce37dd6b927730161a1e559c2336d0a', // 这个的含义??
  did: 0,
  aid: {
    android: 1,
    iOS: 2,
    h5: 3,
    pc: 6,
    business_pc: 4, //商家后台
    operational_pc: 5, //运营后台
    operational_h5: 7 //运营后台h5
  },
  ch: {
    wap: 'wap',
    weixin: 'weixin',
    app: 'app'
  },
  lat: 0,
  lng: 0
}

function syncUserInfo(user) {
  //TODO: 同步用户信息，_tk _uid
  Cookies.set('_uid', user.uid, {
    domain: COOKIE_DOMAIN
  })
  Cookies.set('_wtk', user.token, {
    domain: COOKIE_DOMAIN
  })
}
function syncOrgId(org) {
  //TODO: 同步用户信息，_orgid
  Cookies.set('_orgid', org.id, {
    domain: COOKIE_DOMAIN
  })
}

function syncShopId(shop) {
  Cookies.set('_shopid', shop.id, {
    domain: COOKIE_DOMAIN
  })
}

function removeUserInfo() {
  //TODO: 移除用户信息，_tk _uid
  Cookies.remove('_uid', {
    domain: COOKIE_DOMAIN
  })
  Cookies.remove('_wtk', {
    domain: COOKIE_DOMAIN
  })
  Cookies.remove('_orgid', {
    domain: COOKIE_DOMAIN
  })
  Cookies.remove('_shopid', {
    domain: COOKIE_DOMAIN
  })
}

function isLogin() {
  return !!getUserId()
}

export {
  encryptRequestParam,
  getWebToken,
  getUserId,
  defaultParams,
  syncUserInfo,
  removeUserInfo,
  isLogin,
  syncOrgId,
  syncShopId
}
